import React, { PropsWithChildren } from 'react';
import { Footer } from './Footer';
import { Header } from './Header';

const Layout: React.FC<PropsWithChildren> = ({ children }) => (
  <>
    <div>
      <Header />
      {children}
    </div>
    <Footer />
  </>
);

export default Layout;
